import { Card, Button, Checkbox, Tooltip } from '@mui/material';
import { GameDiv } from '../../../components/GameDiv';
import { EVPercent } from '../../../components/EVPercent';
// import { LogoGenerator } from '../../../components/LogoGenerator';
import { BookAndLink } from './BookAndLink';
import { getRelatedOdds } from '../../../utils/api/getRelatedOdds';
import { RelatedOddsDropdown } from './RelatedOddsDropdown';
import { BetPriceDirection } from './BetPriceDirection';
import { devigOddsProbit, calculateConfidenceWithBreakdown, convertDecimalToAmerican } from '../utils';
import { setBetPlaced, removeBetPlaced } from '../../../utils/api/setBetPlaced';
import { removeObjectWithProperty } from './evScreenTable';
import { ConfidenceDisplay } from './ConfidenceDisplay';

export function MobileEVCard(props) {
	// console.log('props: ', props);
	const {
		dataRow,
		sharpBook,
		sharpLink,
		betPrice,
		sharpPrice,
		limit,
		quarter_kelly,
		ev_value,
		link,
		bet_price_direction_dumb,
		bet_price_direction_sharp,
		isPriceHistoryLoading,
		betName,
		relatedOdds,
		setRelatedOdds,
		preloadedRelatedOdds,
		isPreloadingData,
		setSelectedRow,
		selectedRow,
		overSide,
		underSide,
		isLive,
		sharpPriceOver,
		sharpPriceUnder,
		setSelectedRowIndex,
		index,
		setIsUpgradeModalOpen,
		user,
		isMaster,
		placedBets,
		setPlacedBets,
		bankroll,
		sharpFilter,
	} = props;

	// Calculate fair value using the same logic as desktop table
	let fairValue = 0;
	let plusOrMinusFairValue = '+';
	
	// Check if we have valid sharp prices
	const hasValidSharpPrices = sharpPriceOver && sharpPriceUnder && 
		!isNaN(Number(sharpPriceOver)) && !isNaN(Number(sharpPriceUnder)) &&
		Number(sharpPriceOver) !== 0 && Number(sharpPriceUnder) !== 0;
	
		if (!hasValidSharpPrices) {
		// Try to use devigged5 if available as a fallback
		if (dataRow.devigged5 && !isNaN(dataRow.devigged5)) {
			// Convert devigged5 (which appears to be a probability) to American odds
			const impliedProb = dataRow.devigged5;
			const decimalOdds = 1 / impliedProb;
			let calculatedValue = convertDecimalToAmerican(decimalOdds);
			// Round to whole number
			calculatedValue = Math.round(calculatedValue);
			
			// For Point Spread, apply sign matching logic
			if (dataRow.market === 'Point Spread' || dataRow.market === 'Asian Handicap') {
				const betPriceSign = betPrice.includes('-') ? -1 : 1;
				const deviggedSign = calculatedValue < 0 ? -1 : 1;
				
				// If signs don't match, reverse the fair value
				if (betPriceSign !== deviggedSign) {
					fairValue = -calculatedValue;
					console.log('Sign mismatch - reversing fair value:', { betPrice, betPriceSign, calculatedValue, deviggedSign, fairValue });
				} else {
					fairValue = calculatedValue;
				}
				plusOrMinusFairValue = fairValue < 0 ? '' : '+';
			} else {
				fairValue = calculatedValue;
				plusOrMinusFairValue = fairValue < 0 ? '' : '+';
			}
		} else {
			// No valid data available
			fairValue = NaN;
			plusOrMinusFairValue = '+';
		}
	} else if (dataRow.market === 'Point Spread' || dataRow.market === 'Asian Handicap') {
		if (dataRow.ev_spread === dataRow.ev_over_positive) {
			const deviggedOdds = devigOddsProbit(Number(sharpPriceOver), Number(sharpPriceUnder)).overOdds;
			fairValue = deviggedOdds;
			// Round to whole number
			fairValue = Math.round(fairValue);
			plusOrMinusFairValue = deviggedOdds < 0 ? '' : '+';
		} else if (dataRow.ev_spread === dataRow.ev_under_positive) {
			const deviggedOdds = devigOddsProbit(Number(sharpPriceOver), Number(sharpPriceUnder)).underOdds;
			fairValue = deviggedOdds;
			// Round to whole number
			fairValue = Math.round(fairValue);
			plusOrMinusFairValue = deviggedOdds < 0 ? '' : '+';
		} else if (dataRow.ev_spread === dataRow.ev_over_negative) {
			const deviggedOdds = devigOddsProbit(Number(sharpPriceOver), Number(sharpPriceUnder)).overOdds;
			fairValue = deviggedOdds;
			// Round to whole number
			fairValue = Math.round(fairValue);
			plusOrMinusFairValue = deviggedOdds < 0 ? '' : '+';
		} else if (dataRow.ev_spread === dataRow.ev_under_negative) {
			const deviggedOdds = devigOddsProbit(Number(sharpPriceOver), Number(sharpPriceUnder)).underOdds;
			fairValue = deviggedOdds;
			// Round to whole number
			fairValue = Math.round(fairValue);
			plusOrMinusFairValue = deviggedOdds < 0 ? '' : '+';
		}
		
		// For point spread bets, ensure the fair value sign matches the bet price sign
		const betPriceNum = parseFloat(betPrice.replace(/[+\-]/g, ''));
		const betPriceSign = betPrice.includes('-') ? -1 : 1;
		const deviggedSign = fairValue < 0 ? -1 : 1;
		
		// If signs don't match, reverse the fair value
		if (betPriceSign !== deviggedSign) {
			fairValue = -fairValue;
			plusOrMinusFairValue = fairValue < 0 ? '' : '+';
		}
	} else if (dataRow.market === 'Moneyline') {
		if (dataRow.ev_over > dataRow.ev_under) {
			const deviggedOdds = devigOddsProbit(Number(sharpPriceOver), Number(sharpPriceUnder)).overOdds;
			fairValue = deviggedOdds;
			// Round to whole number
			fairValue = Math.round(fairValue);
			plusOrMinusFairValue = deviggedOdds < 0 ? '' : '+';
		} else {
			const deviggedOdds = devigOddsProbit(Number(sharpPriceOver), Number(sharpPriceUnder)).underOdds;
			fairValue = deviggedOdds;
			// Round to whole number
			fairValue = Math.round(fairValue);
			plusOrMinusFairValue = deviggedOdds < 0 ? '' : '+';
		}
	} else {
		// For totals and other markets
		if (dataRow.ev_over > dataRow.ev_under) {
			const deviggedOdds = devigOddsProbit(Number(sharpPriceOver), Number(sharpPriceUnder)).overOdds;
			fairValue = deviggedOdds;
			// Round to whole number
			fairValue = Math.round(fairValue);
			plusOrMinusFairValue = deviggedOdds < 0 ? '' : '+';
		} else {
			const deviggedOdds = devigOddsProbit(Number(sharpPriceOver), Number(sharpPriceUnder)).underOdds;
			fairValue = deviggedOdds;
			// Round to whole number
			fairValue = Math.round(fairValue);
			plusOrMinusFairValue = deviggedOdds < 0 ? '' : '+';
		}
	}

	// Calculate market average and bet odds for confidence calculation
	// Use RAW dataRow values (not formatted props) to match desktop exactly
	let marketAverage = 0;
	let betOdds = 0;
	let fairValueForConfidence = null;
	let sharpOppositeSideOdds = null; // Pre-devigged sharp odds for OPPOSITE side (for arb calc)
	let sharpPriceOverRaw = '';
	let sharpPriceUnderRaw = '';
	
	// Determine bet odds, raw sharp prices, and fair value - identical to desktop evScreenTable.js
	if (dataRow.market === 'Point Spread' || dataRow.market === 'Asian Handicap') {
		if (dataRow.ev_spread === dataRow.ev_over_positive) {
			betOdds = dataRow.bet_price_over_positive_dumb;
			sharpPriceOverRaw = dataRow.bet_price_over_positive_sharp;
			sharpPriceUnderRaw = dataRow.bet_price_under_negative_sharp;
			let deviggedOdds = devigOddsProbit(Number(sharpPriceOverRaw), Number(sharpPriceUnderRaw)).overOdds;
			const betPriceSign = betOdds < 0 ? -1 : 1;
			const deviggedSign = deviggedOdds < 0 ? -1 : 1;
			if (betPriceSign !== deviggedSign) deviggedOdds = -deviggedOdds;
			fairValueForConfidence = deviggedOdds;
			sharpOppositeSideOdds = Number(sharpPriceUnderRaw);
		} else if (dataRow.ev_spread === dataRow.ev_under_positive) {
			betOdds = dataRow.bet_price_under_positive_dumb;
			sharpPriceOverRaw = dataRow.bet_price_under_positive_sharp;
			sharpPriceUnderRaw = dataRow.bet_price_over_negative_sharp;
			let deviggedOdds = devigOddsProbit(Number(sharpPriceOverRaw), Number(sharpPriceUnderRaw)).underOdds;
			const betPriceSign = betOdds < 0 ? -1 : 1;
			const deviggedSign = deviggedOdds < 0 ? -1 : 1;
			if (betPriceSign !== deviggedSign) deviggedOdds = -deviggedOdds;
			fairValueForConfidence = deviggedOdds;
			sharpOppositeSideOdds = Number(sharpPriceUnderRaw);
		} else if (dataRow.ev_spread === dataRow.ev_over_negative) {
			betOdds = dataRow.bet_price_over_negative_dumb;
			sharpPriceOverRaw = dataRow.bet_price_over_negative_sharp;
			sharpPriceUnderRaw = dataRow.bet_price_under_positive_sharp;
			let deviggedOdds = devigOddsProbit(Number(sharpPriceOverRaw), Number(sharpPriceUnderRaw)).overOdds;
			const betPriceSign = betOdds < 0 ? -1 : 1;
			const deviggedSign = deviggedOdds < 0 ? -1 : 1;
			if (betPriceSign !== deviggedSign) deviggedOdds = -deviggedOdds;
			fairValueForConfidence = deviggedOdds;
			sharpOppositeSideOdds = Number(sharpPriceUnderRaw);
		} else if (dataRow.ev_spread === dataRow.ev_under_negative) {
			betOdds = dataRow.bet_price_under_negative_dumb;
			sharpPriceOverRaw = dataRow.bet_price_under_negative_sharp;
			sharpPriceUnderRaw = dataRow.bet_price_over_positive_sharp;
			let deviggedOdds = devigOddsProbit(Number(sharpPriceOverRaw), Number(sharpPriceUnderRaw)).underOdds;
			const betPriceSign = betOdds < 0 ? -1 : 1;
			const deviggedSign = deviggedOdds < 0 ? -1 : 1;
			if (betPriceSign !== deviggedSign) deviggedOdds = -deviggedOdds;
			fairValueForConfidence = deviggedOdds;
			sharpOppositeSideOdds = Number(sharpPriceUnderRaw);
		}
	} else if (dataRow.market === 'Moneyline') {
		if (dataRow.ev_over > dataRow.ev_under) {
			betOdds = dataRow.bet_price_over_dumb;
			sharpPriceOverRaw = dataRow.bet_price_over_sharp;
			sharpPriceUnderRaw = dataRow.bet_price_under_sharp;
			fairValueForConfidence = devigOddsProbit(Number(sharpPriceOverRaw), Number(sharpPriceUnderRaw)).overOdds;
			sharpOppositeSideOdds = Number(sharpPriceUnderRaw);
		} else {
			betOdds = dataRow.bet_price_under_dumb;
			sharpPriceOverRaw = dataRow.bet_price_over_sharp;
			sharpPriceUnderRaw = dataRow.bet_price_under_sharp;
			fairValueForConfidence = devigOddsProbit(Number(sharpPriceOverRaw), Number(sharpPriceUnderRaw)).underOdds;
			sharpOppositeSideOdds = Number(sharpPriceOverRaw);
		}
	} else {
		if (dataRow.ev_over > dataRow.ev_under) {
			betOdds = dataRow.bet_price_over_dumb;
			sharpPriceOverRaw = dataRow.bet_price_over_sharp;
			sharpPriceUnderRaw = dataRow.bet_price_under_sharp;
			fairValueForConfidence = devigOddsProbit(Number(sharpPriceOverRaw), Number(sharpPriceUnderRaw)).overOdds;
			sharpOppositeSideOdds = Number(sharpPriceUnderRaw);
		} else {
			betOdds = dataRow.bet_price_under_dumb;
			sharpPriceOverRaw = dataRow.bet_price_over_sharp;
			sharpPriceUnderRaw = dataRow.bet_price_under_sharp;
			fairValueForConfidence = devigOddsProbit(Number(sharpPriceOverRaw), Number(sharpPriceUnderRaw)).underOdds;
			sharpOppositeSideOdds = Number(sharpPriceOverRaw);
		}
	}
	
	// Determine overSide/underSide for market average calculation
	// Must match exactly what RelatedOddsDropdown receives as props
	let overSideForAvg = 'bet_price_over';
	let underSideForAvg = 'bet_price_under';
	let isSpreadForAvg = false;
	
	if (dataRow.market === 'Point Spread' || dataRow.market === 'Asian Handicap') {
		isSpreadForAvg = true;
		if (dataRow.ev_spread === dataRow.ev_over_positive) {
			overSideForAvg = 'bet_price_over_positive';
			underSideForAvg = 'bet_price_under_negative';
		} else if (dataRow.ev_spread === dataRow.ev_under_positive) {
			overSideForAvg = 'bet_price_over_negative';
			underSideForAvg = 'bet_price_under_positive';
		} else if (dataRow.ev_spread === dataRow.ev_over_negative) {
			overSideForAvg = 'bet_price_over_negative';
			underSideForAvg = 'bet_price_under_positive';
		} else if (dataRow.ev_spread === dataRow.ev_under_negative) {
			overSideForAvg = 'bet_price_over_positive';
			underSideForAvg = 'bet_price_under_negative';
		}
	}
	
	// Determine if this is an "over" or "under" bet for picking the right average column
	let isOverBetForAvg;
	if (dataRow.market === 'Point Spread' || dataRow.market === 'Asian Handicap') {
		isOverBetForAvg = dataRow.ev_spread === dataRow.ev_over_positive || 
					dataRow.ev_spread === dataRow.ev_over_negative;
	} else {
		isOverBetForAvg = dataRow.ev_over > dataRow.ev_under;
	}
	
	// Try to get relatedOdds using the SAME priority as desktop:
	// 1. Selected row's relatedOdds (most accurate, from click)
	// 2. Lazy-loaded relatedOdds (from viewport-based fetching)
	// 3. Preloaded relatedOdds (from evScreen preload)
	let rowRelatedOdds = null;
	if (relatedOdds && relatedOdds.length > 0 && selectedRow?.outcome_id_normalized === dataRow.outcome_id_normalized) {
		rowRelatedOdds = relatedOdds;
	} else if (dataRow._lazyRelatedOdds && Array.isArray(dataRow._lazyRelatedOdds) && dataRow._lazyRelatedOdds.length > 0) {
		rowRelatedOdds = dataRow._lazyRelatedOdds;
	} else if (preloadedRelatedOdds && preloadedRelatedOdds.has(dataRow.outcome_id_normalized_no_book)) {
		rowRelatedOdds = preloadedRelatedOdds.get(dataRow.outcome_id_normalized_no_book);
	}

	// Calculate market average using the EXACT same logic as RelatedOddsDropdown
	if (rowRelatedOdds && rowRelatedOdds.length > 0) {
		// pickPrice: matches RelatedOddsDropdown.js exactly
		const pickPrice = (row, primaryKey, isSpread) => {
			const val = row?.[primaryKey];
			if (val != null) return val;
			if (!isSpread) return null;
			if (primaryKey?.startsWith('bet_price_over')) {
				return row?.bet_price_over_positive ?? row?.bet_price_over_negative ?? row?.bet_price_over ?? null;
			}
			if (primaryKey?.startsWith('bet_price_under')) {
				return row?.bet_price_under_positive ?? row?.bet_price_under_negative ?? row?.bet_price_under ?? null;
			}
			return null;
		};
		
		// americanToDecimal: matches RelatedOddsDropdown.js exactly (with .toFixed(2))
		const americanToDecimal = (oddsStr) => {
			const odds = parseFloat(oddsStr);
			if (isNaN(odds)) return null;
			if (odds > 0) return (odds / 100 + 1).toFixed(2);
			return (100 / Math.abs(odds) + 1).toFixed(2);
		};
		
		// decimalToAmerican: matches RelatedOddsDropdown.js exactly
		const decimalToAmerican = (decimal) => {
			if (decimal == null) return null;
			if (decimal >= 2.0) return Math.round((decimal - 1) * 100);
			if (decimal < 2.0 && decimal > 1) return Math.round(-100 / (decimal - 1));
			return null;
		};
		
		// Use the correct price field based on bet side
		const avgPriceField = isOverBetForAvg ? overSideForAvg : underSideForAvg;
		
		const decimalOdds = rowRelatedOdds
			.filter((e) => pickPrice(e, avgPriceField, isSpreadForAvg) != null)
			.map((e) => {
				try {
					const americanOdds = pickPrice(e, avgPriceField, isSpreadForAvg);
					if (americanOdds == null) return null;
					return parseFloat(americanToDecimal(americanOdds));
				} catch (err) {
					return null;
				}
			})
			.filter((d) => d != null);
		
		if (decimalOdds.length > 0) {
			const avgDecimal = decimalOdds.reduce((total, next) => total + next, 0) / decimalOdds.length;
			const result = decimalToAmerican(avgDecimal);
			if (result != null) {
				marketAverage = result;
			}
		}
	}
	// If no relatedOdds available or calculation fails, marketAverage stays at 0 → excluded from score

	// Check if we have price history data in links (needed for line movement calculation)
	// For Point Spread markets, check positive/negative history fields as well
	const hasPriceHistory = (
		// Standard over/under history fields (used for Moneyline and other markets)
		(Array.isArray(dataRow.link?.bet_price_over_history) && dataRow.link.bet_price_over_history.length > 0) ||
		(Array.isArray(dataRow.link?.bet_price_under_history) && dataRow.link.bet_price_under_history.length > 0) ||
		(Array.isArray(dataRow.sharpLink?.bet_price_over_history) && dataRow.sharpLink.bet_price_over_history.length > 0) ||
		(Array.isArray(dataRow.sharpLink?.bet_price_under_history) && dataRow.sharpLink.bet_price_under_history.length > 0) ||
		// Positive/negative history fields (used for Point Spread markets)
		(Array.isArray(dataRow.link?.bet_price_history_over_positive) && dataRow.link.bet_price_history_over_positive.length > 0) ||
		(Array.isArray(dataRow.link?.bet_price_history_over_negative) && dataRow.link.bet_price_history_over_negative.length > 0) ||
		(Array.isArray(dataRow.link?.bet_price_history_under_positive) && dataRow.link.bet_price_history_under_positive.length > 0) ||
		(Array.isArray(dataRow.link?.bet_price_history_under_negative) && dataRow.link.bet_price_history_under_negative.length > 0) ||
		(Array.isArray(dataRow.sharpLink?.bet_price_history_over_positive) && dataRow.sharpLink.bet_price_history_over_positive.length > 0) ||
		(Array.isArray(dataRow.sharpLink?.bet_price_history_over_negative) && dataRow.sharpLink.bet_price_history_over_negative.length > 0) ||
		(Array.isArray(dataRow.sharpLink?.bet_price_history_under_positive) && dataRow.sharpLink.bet_price_history_under_positive.length > 0) ||
		(Array.isArray(dataRow.sharpLink?.bet_price_history_under_negative) && dataRow.sharpLink.bet_price_history_under_negative.length > 0)
	);
	
	// Don't calculate confidence until price history is loaded (line movement verified)
	// This ensures the confidence score is accurate with real line movement data
	const shouldShowLoading = isPriceHistoryLoading;
	
	const confidenceData = shouldShowLoading 
		? { confidence: null, breakdown: null }
		: calculateConfidenceWithBreakdown(
			dataRow, 
			marketAverage, 
			sharpFilter, 
			fairValueForConfidence, 
			betOdds,
			null, // availableBooks
			{
				sharpDirection: bet_price_direction_sharp,
				dumbDirection: bet_price_direction_dumb,
				sharpOppositeSideOdds: sharpOppositeSideOdds
			}
		);

	const percentOfTotalBankroll = placedBets?.find((placedbet) => placedbet.id === dataRow.outcome_id_normalized)?.value / bankroll;
	
	// Calculate recommended bet size in dollars (quarter kelly * 1% of bankroll)
	// Round to nearest hundredth for bets under $100, nearest one for bets over $100
	let recommendedBetSize = '0';
	if (bankroll) {
		const betAmount = quarter_kelly * (bankroll * 0.01); // 1% of bankroll
		if (betAmount < 100) {
			recommendedBetSize = Math.round(betAmount * 100) / 100;
			recommendedBetSize = recommendedBetSize.toFixed(2);
		} else {
			recommendedBetSize = Math.round(betAmount);
		}
		recommendedBetSize = recommendedBetSize.toLocaleString();
	}
	return (
		<Card sx={{ 
			backgroundColor: '#1a1d23', 
			border: '1px solid #2d3748', 
			borderRadius: '12px',
			boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
		}} className="w-full max-w-md mx-auto overflow-hidden">
			
			{/* Header - Game Info & EV */}
			<div className="p-4 border-b border-gray-700">
				<div className="flex items-center justify-between mb-2">
					<div className="flex-1 min-w-0">
						<div className="text-white">
							<GameDiv dataRow={dataRow} />
						</div>
					</div>
					<div className="flex items-center gap-2 ml-3">
						<EVPercent ev={ev_value} />
					</div>
				</div>
				<div className="flex items-center justify-between">
					<div className="text-sm text-white">
						{dataRow.league} • {dataRow.market}
					</div>
					{process.env.REACT_APP_CONFIDENCE !== 'false' && (
						<div className="flex items-center gap-2">
							<span className="text-xs text-gray-400">Confidence</span>
							<ConfidenceDisplay 
								confidence={confidenceData.confidence}
								calculationBreakdown={confidenceData.breakdown}
								isLoading={shouldShowLoading}
								selected={selectedRow?.outcome_id_normalized === dataRow.outcome_id_normalized}
								isMobile={true}
							/>
						</div>
					)}
				</div>
			</div>

			{/* Main Bet Section */}
			<div className="p-4 bg-gray-800/50">
				<div className="mb-3">
					<h3 className="text-white font-semibold text-base leading-tight">{betName}</h3>
				</div>
				
				{/* Betting Info Row */}
				<div className="flex items-center justify-between">
					<BookAndLink isSharp={false} mobile book={dataRow.sportsbook_dumb} link={link} betPrice={betPrice} direction={bet_price_direction_dumb} isLoading={isPriceHistoryLoading} />
				</div>
			</div>

			{/* Sharp Book & Analysis Section */}
			<div className="p-4 bg-gray-900/30">
				<div className="flex items-center justify-between mb-3">
					<div className="flex items-center gap-2">
						<span className="text-xs text-gray-400 uppercase tracking-wide">Sharp Book</span>
					</div>
					<div className="flex items-center gap-2">
						<span className="text-xs text-gray-400 uppercase tracking-wide">Bet Size</span>
						<Tooltip
							title={`Quarter Kelly: ${quarter_kelly?.toFixed(2)}u`}
							componentsProps={{
								tooltip: {
									sx: {
										fontSize: '1.1rem',
									},
								},
							}}>
							<span className="text-white font-semibold text-sm cursor-pointer">${recommendedBetSize}</span>
						</Tooltip>
					</div>
				</div>
				
				<div className="flex items-center justify-between">
					<div className="flex items-center gap-2">
						<BookAndLink isSharp={true} mobile book={sharpBook} link={sharpLink} />
						<BetPriceDirection direction={bet_price_direction_sharp} isLoading={isPriceHistoryLoading} />
					</div>
					<div className="flex items-center gap-2">
						<div className="flex items-center gap-2">
							<span className="text-xs text-gray-400">Fair Value</span>
							<div className="bg-gray-800 px-3 py-2 rounded-lg border border-gray-600 h-8 flex items-center justify-center min-w-[60px]">
								<span className="text-white font-medium text-sm">
									{isNaN(fairValue) ? 'N/A' : (plusOrMinusFairValue + fairValue)}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Limit Info */}
			{limit && sharpBook !== 'WagerWiz' && dataRow.sharp_filter && dataRow.sharp_filter.length === 1 && (
				<div className="px-4 py-2 bg-gray-800/50 border-t border-gray-600/30">
					<div className="text-sm font-medium text-white">
						Limit: <span style={{ color: limit < 1000 ? '#ff4444' : limit < 2500 ? '#ffaa00' : '#44ff44' }}>${limit?.toLocaleString()}</span>
					</div>
				</div>
			)}

			{/* Bet Tracking Section */}
			<div className="p-4 border-t border-gray-700 bg-gray-800/30">
				<div className="flex items-center justify-between mb-3">
					<div className="flex items-center gap-2">
						<Tooltip title="Check this box if you've placed this bet to track it">
							<Checkbox
								sx={{
									color: '#4B5563',
									'&.Mui-checked': {
										color: '#10B981',
									},
									padding: 0,
								}}
								onChange={async (e) => {
									if (isMaster || !user?.email) {
										setIsUpgradeModalOpen(true);
									} else {
										if (dataRow.outcome_id_normalized !== '') {
											if (e.target.checked) {
												await setBetPlaced(dataRow.outcome_id_normalized, user.email);
												setPlacedBets([...placedBets, { id: dataRow.outcome_id_normalized, time: new Date() }]);
											} else {
												const copy = JSON.parse(JSON.stringify(placedBets));
												const newCopy = removeObjectWithProperty(copy, 'id', dataRow.outcome_id_normalized);
												setPlacedBets(newCopy);
												await removeBetPlaced(dataRow.outcome_id_normalized, user.email);
											}
										}
									}
								}}
								checked={placedBets?.some((placedBet) => placedBet.id === dataRow.outcome_id_normalized)}
							/>
						</Tooltip>
						<span className="text-sm text-gray-300">Track this bet</span>
					</div>
					
					{placedBets?.some((placedBet) => placedBet.id === dataRow.outcome_id_normalized) && (
						<div className="flex items-center gap-2">
							<Tooltip title={`${(percentOfTotalBankroll * 100).toFixed(2)}% of bankroll`}>
								<input
									onClick={(e) => {
										e.stopPropagation();
									}}
									type="number"
									placeholder="Amount"
									onChange={async (e) => {
										if (!user?.email) return;
										const copy = JSON.parse(JSON.stringify(placedBets));
										for (const placedbet of copy) {
											if (placedbet.id === dataRow.outcome_id_normalized) {
												placedbet.value = e.target.value;
											}
										}
										setPlacedBets(copy);
										await setBetPlaced(dataRow.outcome_id_normalized, user.email, e.target.value);
									}}
									value={placedBets?.find((placedbet) => placedbet.id === dataRow.outcome_id_normalized)?.value}
									className="w-20 px-2 py-1 text-sm bg-gray-700 border border-gray-600 rounded text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
								/>
							</Tooltip>
						</div>
					)}
				</div>

				{/* View Details Button */}
				<Button
					onClick={async () => {
						if (selectedRow?.outcome_id_normalized === dataRow.outcome_id_normalized) {
							setSelectedRow();
							setSelectedRowIndex(null);
						} else {
							if (dataRow.outcome_id_normalized !== '') {
								setSelectedRow(dataRow);
								setSelectedRowIndex(index);
									const relatedOdds = await getRelatedOdds(
										dataRow.outcome_id_normalized_no_book,
										dataRow.sport,
										{ market: dataRow.market, points: dataRow.points, home_team: dataRow.home_team }
									);
								setRelatedOdds(relatedOdds);
							} else {
								setIsUpgradeModalOpen(true);
							}
						}
					}}
					className="w-full py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 font-semibold rounded-lg transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] shadow-lg hover:shadow-xl"
					style={{
						textTransform: 'none',
						fontSize: '14px',
						color: 'white',
					}}>
					{selectedRow?.outcome_id_normalized === dataRow.outcome_id_normalized ? 'Hide Details' : 'View Details'}
				</Button>
			</div>

			{selectedRow?.outcome_id_normalized === dataRow.outcome_id_normalized && relatedOdds && (
				<RelatedOddsDropdown
					relatedOdds={relatedOdds}
					isOver={dataRow.ev_over > dataRow.ev_under}
					sportsbooksToHighlight={[...(dataRow.sharp_book ? [...new Set(dataRow.sharp_book.split(',').map(b => b.trim()))] : []), dataRow.sportsbook_dumb]}
					sportsbook_dumb={dataRow.sportsbook_dumb}
					outcome_id_normalized={selectedRow?.outcome_id_normalized}
					sharpBook={dataRow.sharp_book}
					sharpFilter={dataRow.sharp_filter}
					isMobile={true}
					fairValue={fairValue}
					selectedRow={selectedRow}
					overSide={overSide}
					underSide={underSide}
					isLive={isLive}
					sharpPriceOver={sharpPriceOver}
					sharpPriceUnder={sharpPriceUnder}
					sharpPrice={sharpPrice}
				/>
			)}
		</Card>
	);
}
